'use strict';

var feedbackIdCounter = 0;

/**
 * Links (or unlinks) a field to its error message for assistive tech (WCAG 1.3.1, 3.3.1, 4.1.2).
 * Error messages are referenced via aria-describedby only while visible, so screen readers
 * don't read a hidden "required field" message as the field description.
 * Mirrors setFieldErrorA11y in assets/src/scripts/utilities/formUtils.ts.
 * @param {HTMLElement} field - the input/select
 * @param {HTMLElement} feedback - the .invalid-feedback element of the field
 * @param {boolean} invalid - true to flag the error, false to clear it
 */
function setFieldErrorA11y(field, feedback, invalid) {
    if (!field) return;

    if (feedback && !feedback.id) {
        feedbackIdCounter += 1;
        feedback.id = 'field-error-legacy-' + feedbackIdCounter;
    }

    var feedbackId = feedback ? feedback.id : null;
    var otherIds = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) {
        return id && id !== feedbackId;
    });

    if (invalid) {
        field.setAttribute('aria-invalid', 'true');
        if (feedbackId) field.setAttribute('aria-describedby', otherIds.concat(feedbackId).join(' '));
        return;
    }

    field.removeAttribute('aria-invalid');
    if (otherIds.length) {
        field.setAttribute('aria-describedby', otherIds.join(' '));
    } else {
        field.removeAttribute('aria-describedby');
    }
}

module.exports = setFieldErrorA11y;
